export const initFilterState = () => ({
  matched: '',
  applied: '',
  shortlisted: '',
  interviewed: '',
  offered: '',
  hired: '',
  rejected: '',
})

export const initSearchState = () => ({
  matched: '',
  applied: '',
  shortlisted: '',
  interviewed: '',
  offered: '',
  hired: '',
  rejected: '',
})

export const initAppIdState = () => ({
  matched: '',
  applied: '',
  shortlisted: '',
  interviewed: '',
  offered: '',
  hired: '',
  rejected: '',
})
